<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Edit Video Session">
      <div class="row">
        <div class="col-md-6 form-group">
          Name
          <input
            class="form-control"
            type="text"
            v-model="name"
            @focus="nameEmpty = false"
          />
          <div v-if="nameEmpty" style="color: red">Name is required</div>
        </div>

        <div class="col-md-6 form-group">
          Video URL
          <input
            class="form-control"
            type="text"
            v-model="videoURL"
            @focus="videoURLEmpty = false"
          />
          <div v-if="videoURLEmpty" style="color: red">
            Video URL is required
          </div>
        </div>

        <div class="col-md-6 form-group">
          Estimated Date
          <b-form-datepicker
            v-model="estimatedDate"
            @input="estimatedDateEmpty = false"
          ></b-form-datepicker>
          <div v-if="estimatedDateEmpty" style="color: red">Estimated date is required</div>
        </div>

        <div class="col-md-6 form-group">
          Estimated Time
          <b-form-timepicker
            v-model="estimatedTime"
            @input="estimatedTimeEmpty = false"
          ></b-form-timepicker>
          <div v-if="estimatedTimeEmpty" style="color: red">Estimated time is required</div>
        </div>

      </div>
      <div class="text-center">
        <b-button
          class="text-center"
          variant="success"
          style="margin-bottom: 20px"
          @click="editVideoSession()"
          >Save Changes</b-button
        >
      </div>
    </base-block>
    <br />
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      estimatedDate: "",
      estimatedDateEmpty: false,
      estimatedTime: "",
      estimatedTimeEmpty: false,
      id: "",
      videoURLEmpty: false,
      nameEmpty: false,
      name: "",
      videoURL: ""
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/video-sessions/edit/${this.$route.params.id}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.id = response.data.admin.id;
            this.name = response.data.admin.name;
            this.videoURL = response.data.admin.video_url;
            this.estimatedDate = response.data.admin.end_date_time.split(" ")[0]
            this.estimatedTime = response.data.admin.end_date_time.split(" ")[1]
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async editVideoSession() {
      if (this.name == "") {
        this.nameEmpty = true;
        return;
      }

      if (this.videoURL == "") {
        this.videoURLEmpty = true;
        return;
      }

      if(this.estimatedDate == "") {
        this.estimatedDateEmpty = true
        return
      }

      if(this.estimatedTime == "") {
        this.estimatedTimeEmpty = true
        return
      }

      const formdata = new FormData();
      formdata.append("name", this.name);
      formdata.append("video_url", this.videoURL);
      formdata.append("end_date", this.estimatedDate);
      formdata.append("end_time", this.estimatedTime);
      await axios
        .post(
          `${this.$store.getters.baseUrl}/video-sessions/update/${this.id}`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.$swal(
              "Success",
              "Video session updated successfully",
              "success"
            );
            this.$router.push({name: 'Tables VideoSessions'});
            this.name = "";
            this.videoURL = "";
            this.nameEmpty = false;
            this.videoURLEmpty = false;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>

